// extracted by mini-css-extract-plugin
export default {"inputRoot":"DateRangeInput_inputRoot__GDO+Z","withMobileMargins":"DateRangeInput_withMobileMargins__saoUS","arrowIcon":"DateRangeInput_arrowIcon__PvEb-"};